<app-button
    class="pointer-events-auto"
    [icon]="['far', 'rectangle-history-circle-plus']"
    [label]="title() | transloco"
    [type]="ButtonType.SECONDARY"
    (onClick)="broadcastChannelService.handleOpenInNewWindow(windowPath())" />
